import React from 'react';
import './Error.css'; // Import the CSS file

const Error = () => {
  return (
    <div className="error-container">
      <h1 className="error-heading">404 - Page Not Found</h1>
    </div>
  );
};

export default Error;
